<template>
  <div id="ticketManageTabs">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane v-for="item in tabs" :key="item.name" :name="item.name">
        <template slot="label">
          <i v-if="item.icon" :class="item.icon" style="margin-right: 4px"></i>{{ item.label }}
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="content" v-show="tabs.length > 0">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "ticketManageTabs",
  data() {
    return {
      // tabs列表
      tabs: [],
      tabAction: null,
    };
  },
  computed: {
    ...mapGetters({ 'permissionsGetter': 'permissionsGetter' })
  },
  watch: {
    tabAction(val) {
      this.$router.push(val);
    },
    $route: {
      handler(val) {
        this.tabAction = val.path;
        if (val.path == '/ticketManage' && this.tabs.length > 0) {
          this.$nextTick(() => {
            this.tabAction = this.tabs[0].name;
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.mixinOrganizations();
    let tabs = [];
    setTimeout(() => {
      if (this.menuPreFn(74)) tabs.push({ label: "票据入库", name: "/ticketManagePush", icon: 'el-icon-box' });
      if (this.menuPreFn(75)) tabs.push({ label: "票据领取", name: "/ticketManageGet", icon: 'el-icon-receiving' });

      this.tabs = tabs;
      this.tabAction = this.tabAction && this.tabAction != '/ticketManage' ? this.tabAction : tabs[0].name;
    }, this.permissionsGetter.length > 0 ? 0 : 1500)
  },
};
</script>

<style lang="less">
#ticketManageTabs {
  height: 100%;

  .content {
    height: calc(100% - 40px);

    & > div {
      height: 100%;
    }
  }
}
</style>

